import { Breadcrumb, Heading, Page } from 'components';
import { ReactElement, useCallback } from 'react';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import { type CampaignsView, campaignViews } from './types';

import useLocalStorageState from 'use-local-storage-state';
import { CampaingsViewContainer } from './CampaingsViewContainer';

export function MyCampaigns(): ReactElement {
  const [storedView, setStoredView] = useLocalStorageState<CampaignsView>('_my_campaings_view', {
    defaultValue: 'all',
  });

  const { view, '*': wildcardPath } = useParams<{ view: CampaignsView; '*': string }>();
  const navigate = useNavigate();

  // when change the role keep the current stage if there is one
  const setView = useCallback(
    (nextView: CampaignsView) => {
      setStoredView(nextView);
      const suffix = wildcardPath ? `/${wildcardPath}` : '';
      const to = view ? `../${nextView}${suffix}` : `${nextView}${suffix}`;
      navigate(to, { relative: 'path' });
    },
    [view, wildcardPath, navigate, setStoredView],
  );

  if (!view || !campaignViews.includes(view)) {
    const to = view ? `../${storedView}` : storedView;
    return <Navigate to={to} replace relative="path" />;
  }

  return (
    <Page>
      <Breadcrumb to={null}>My campaigns</Breadcrumb>
      <Heading title="My campaigns" />

      <CampaingsViewContainer view={view} setView={setView} />
    </Page>
  );
}
